import Vue from 'vue';

// Time ago
import TimeAgo from 'javascript-time-ago';
import nl from 'javascript-time-ago/locale/nl';
TimeAgo.addLocale(nl);
const timeAgo = new TimeAgo('nl-NL');

Vue.filter('timeAgo', function(value) {
    return timeAgo.format(new Date(value));
});

// Date
var moment = require('moment');

Vue.filter('date', function(value) {
    return moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm');
});
